import { ErrorMessage, Field } from "formik";
import React, { useState, useContext } from "react";
import { IoMdAdd, IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { years } from "../../../functions/YearGenerate";
import {
  concentration,
  concentrationProduct,
  industry,
  operationRange,
} from "../../../mock/DropdownOptions";
import SelectField from "../../common/form/SelectField";
import InputField from "./../../common/form/InputField";
import { AppContext } from "../../../context/AppContext";

const ProfessionalInfo = () => {
  const [experienceCount, setExperienceCount] = useState(1);
  const { profileType } = useContext(AppContext);

  const addExperience = () => {
    if (experienceCount < 10) {
      setExperienceCount((prevCount) => prevCount + 1);
    } else {
      toast.error("You can add only up to 10 experiences.");
    }
  };

  const deleteExperience = (index) => {
    const updatedCount = experienceCount - 1;
    setExperienceCount(updatedCount);
  };

  const renderExperienceFields = () => {
    const fields = [];
    for (let i = 1; i <= experienceCount; i++) {
      fields.push(
        <div key={i}>
          <div className="flex items-center justify-between mt-5">
            <span className="text-gray-900 mt-5 flex items-center gap-2 cursor-pointer">
              Professional Experience {i}
            </span>
            <button
              type="button"
              onClick={() => deleteExperience(i)}
              className="text-red-500 hover:text-red-700"
            >
              <IoMdClose />
            </button>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-2">
              <InputField
                type={"text"}
                label={"Company Name"}
                name={`CompanyProfessionalExperience${i}`}
                required={i === 1}
              />
            </div>
            <div className="sm:col-span-2">
              <InputField
                type={"text"}
                label={"Position"}
                name={`PositionProfessionalExperience${i}`}
                required={i === 1}
              />
            </div>
            <div className="sm:col-span-2">
              <SelectField
                selectoptions={years}
                title={"Year"}
                name={`YearProfessionalExperience${i}`}
                required={i === 1}
              />
            </div>
          </div>
        </div>
      );
    }
    return fields;
  };

  const renderConcentrationField = () => {
    return (
      <div className="sm:col-span-2">
        <div>
          <label
            htmlFor="concentration"
            className="block text-sm font-medium leading-6 text-gray-500"
          >
            Concentration <span className="text-red-500">*</span>
          </label>
          <Field
            as="select"
            name="Concentration"
            className="w-full border border-gray-300 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
          >
            <option value="" disabled selected>
              Select an option
            </option>
            {profileType === "Product"
              ? concentrationProduct.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))
              : concentration.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
          </Field>
          <ErrorMessage
            name="Concentration"
            component="div"
            className="text-red-500 text-xs"
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="mt-5">
        <h1 className="text-md font-semibold ">PROFESSIONAL INFO</h1>
        <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          {(profileType === "Professional" ||
            profileType === "Student" ||
            profileType === "Professor") && (
            <div className="sm:col-span-2">
              <InputField
                type={"text"}
                label={"Professional Position"}
                name={"ProfessionPositionName"}
                required
              />
            </div>
          )}

          <div className="sm:col-span-2">
            <SelectField
              selectoptions={years}
              title={"Start Year in the Industry"}
              name="StartYear"
              required
            />
          </div>
          {(profileType === "Company" || profileType === "Product") && (
            <div className="sm:col-span-2">
              <SelectField
                selectoptions={operationRange}
                title={"Operations"}
                name="Operations"
                required
              />
            </div>
          )}

          <div className="sm:col-span-2">
            <SelectField
              selectoptions={industry}
              title={"Industry"}
              name="Industry"
              required
            />
          </div>
          {renderConcentrationField()}
        </div>

        {(profileType === "Professional" ||
          profileType === "Student" ||
          profileType === "Professor") && (
          <>
            {renderExperienceFields()}
            <Link
              type="button"
              onClick={addExperience}
              className="mt-4 mb-4 text-blue-900 flex items-center gap-2 underline font-bold py-2 px-4 rounded"
            >
              <IoMdAdd /> Add Experience
            </Link>
          </>
        )}
      </div>
    </>
  );
};

export default ProfessionalInfo;
